module.exports = __webpack_public_path__ + "img/icon_kefu.89a7c703.png";